export default __webpack_public_path__ + "static/media/xber.f70e2474.png";